class SwipeButton {
	swipeButton: HTMLAnchorElement;
	swipeElement: HTMLElement;
	private startX = 0;
	private startY = 0;
	private endX = 0;
	private deltaX = 0;
	private deltaY = 0;

	constructor(swipeButton: string, swipeElement: string) {
		this.swipeButton = document.querySelector(swipeButton);
		this.swipeElement = document.querySelector(swipeElement);

		if (!this.swipeButton || !this.swipeElement)
			return;

		this.swipeButton.addEventListener("touchstart", (event) => {
			this.calculations();
			this.touchstart(event);
		});

		this.swipeButton.addEventListener("touchmove", (event) => {
			this.touchmove(event);
		});

		this.swipeButton.addEventListener("touchend", () => {
			this.touchend();
		});
	}

	calculations() {
		const swipeButtonStyle = window.getComputedStyle(this.swipeButton);
		this.endX = this.swipeButton.getBoundingClientRect().width - parseInt(swipeButtonStyle.paddingLeft) - parseInt(swipeButtonStyle.paddingRight) - parseInt(swipeButtonStyle.borderWidth) - this.swipeElement.getBoundingClientRect().width;
	}

	touchstart(event: TouchEvent) {
		this.startX = event.touches[0].clientX;
		this.startY = event.touches[0].clientY;
	}

	touchmove(event: TouchEvent) {
		event.preventDefault();
		this.deltaX = event.touches[0].clientX - this.startX;
		this.deltaY = event.touches[0].clientY - this.startY;

		if (Math.abs(this.deltaX) > Math.abs(this.deltaY)) {
			if (this.deltaX > 0 && this.deltaX <= this.endX) {
				this.swipeElement.style.transform = `translateX(${ this.deltaX }px)`;
			} else {
				// Свайп влево (можно реализовать по желанию)
			}
		} else {
			if (this.deltaY > 0) {
				// Свайп вниз (можно реализовать по желанию)
			} else {
				// Свайп вверх (можно реализовать по желанию)
			}
		}
	}

	touchend() {
		if (this.deltaX >= (this.endX - 10)) {
			this.swipeElement.style.transform = `translateX(${ this.endX }px)`;
			this.swipeButton.classList.add('_active');

			setTimeout(() => {
				location.href = this.swipeButton.href;
			}, 700);
		} else {
			this.swipeElement.style.transform = "translateX(0)";
		}
	}
}

export default SwipeButton;
